import { BettingGroup } from "@ppb/tbd-store/state/betting/sportsbook-betting/SportsbookBetting.types";
import { ExchangeBetTransactionError } from "../../../services/ExchangeBetTransactionError.types";
import {
  BetslipCastContext,
  BetslipObbReport,
  BetslipSportsbookConfirmationBet,
  BetslipSportsbookReport,
} from "@ppb/tbd-store/state/betslip/Betslip.types";
import { BetslipApplicationState } from "../BetslipApplicationState";
import {
  HandicapMovementState,
  OddsMovementState,
  RequestStatus,
  type BetslipExchangeEdit,
  type BetslipExchangeReport,
  type BetslipExchangeContext,
} from "./betslip-module.types";

export const getIsBetslipLoaded = (appState: BetslipApplicationState): boolean => !!appState.betslipModule;

export const getBetslipPlaceStatus = (appState: BetslipApplicationState): RequestStatus | undefined =>
  appState.betslipModule?.placeStatus;

export const getLastSuccessfulStake = (appState: BetslipApplicationState): number | undefined =>
  appState.betslipModule?.lastSuccessfulStake;

export const getCurrentMultipleContext = (appState: BetslipApplicationState): string | undefined =>
  appState.betslipModule?.sportsbookMultipleContext;

export const getBetslipCastContext = (appState: BetslipApplicationState): BetslipCastContext | undefined =>
  appState.betslipModule?.sportsbookCastContext;

export const getHasSportsbookTechnicalError = (appState: BetslipApplicationState): boolean =>
  !!appState.betslipModule?.hasSportsbookTechnicalError;

export const getIsDepositRedirect = (appState: BetslipApplicationState): boolean =>
  !!appState.betslipModule?.isDepositRedirect;

export const getIsFreeBetsSelected = (appState: BetslipApplicationState): boolean =>
  !!appState.betslipModule?.isFreeBetsSelected;

export const getIsBetBuilderMultisNotificationVisible = (appState: BetslipApplicationState): boolean =>
  !!appState.betslipModule?.isBetBuilderMultisNotificationVisible;

export const getHasEditedUnmatchedBet = (appState: BetslipApplicationState): boolean | undefined =>
  appState.betslipModule?.hasEditedUnmatchedBet;

export const getShowMaxPayoutNotification = (appState: BetslipApplicationState): boolean | undefined =>
  appState.betslipModule?.showMaxPayoutNotification;

export const getHasUserChangedOddsMovementPreference = (appState: BetslipApplicationState): boolean =>
  !!appState.betslipModule?.hasUserChangedOddsMovementPreference;

export const getHasGenerosityWallets = (appState: BetslipApplicationState): boolean | undefined =>
  appState.betslipModule?.hasGenerosityWallets;

export const getHasGenerosityTokens = (appState: BetslipApplicationState): boolean | undefined =>
  appState.betslipModule?.hasGenerosityTokens;

export const getIsReceiptReusePending = (appState: BetslipApplicationState): boolean =>
  !!appState.betslipModule?.isReceiptReusePending;

export const getSportsbookOddsMovement = (appState: BetslipApplicationState): OddsMovementState =>
  appState.betslipModule?.sportsbookOddsMovement ?? {};

export const getObbOddsMovement = (appState: BetslipApplicationState): OddsMovementState =>
  appState.betslipModule?.obbOddsMovement ?? {};

export const getSportsbookHandicapMovement = (appState: BetslipApplicationState): HandicapMovementState =>
  appState.betslipModule?.sportsbookHandicapMovement ?? {};

export const getBetslipExchangeContext = (appState: BetslipApplicationState): BetslipExchangeContext | undefined =>
  appState.betslipModule?.exchangeContext;

export const getBetslipExchangeEdit = (appState: BetslipApplicationState): BetslipExchangeEdit | undefined =>
  appState.betslipModule?.exchangeEdit;

export const getBetslipExchangeReport = (appState: BetslipApplicationState): BetslipExchangeReport | undefined =>
  appState.betslipModule?.exchangeReport;

export const getBetslipExchangePlaceError = (
  appState: BetslipApplicationState,
): ExchangeBetTransactionError | undefined => appState.betslipModule?.exchangePlaceError;

export const getBetslipGroup = (appState: BetslipApplicationState): BettingGroup | undefined =>
  appState.betslipModule?.group;
export const getObbReport = (appState: BetslipApplicationState): BetslipObbReport | undefined =>
  appState.betslipModule?.obbReport;

export const getSportsbookReport = (appState: BetslipApplicationState): BetslipSportsbookReport | undefined =>
  appState.betslipModule?.sportsbookReport;

export const getSportsbookConfirmation = (
  appState: BetslipApplicationState,
): BetslipSportsbookConfirmationBet | undefined => appState.betslipModule?.sportsbookConfirmation;

export const getSportsbookConfirmationCombinations = (
  appState: BetslipApplicationState,
): BetslipSportsbookConfirmationBet["combinations"] => getSportsbookConfirmation(appState)?.combinations || {};

export const getSportsbookConfirmationIgnoredBets = (
  appState: BetslipApplicationState,
): BetslipSportsbookConfirmationBet["ignoredBets"] => getSportsbookConfirmation(appState)?.ignoredBets || [];

export const getSportsbookConfirmationAvailability = (
  appState: BetslipApplicationState,
): BetslipSportsbookConfirmationBet["availabilityChanged"] =>
  getSportsbookConfirmation(appState)?.availabilityChanged || false;

export const getSportsbookConfirmationLegs = (
  appState: BetslipApplicationState,
): BetslipSportsbookConfirmationBet["legs"] => getSportsbookConfirmation(appState)?.legs || {};

export const getSportsbookConfirmationRunners = (
  appState: BetslipApplicationState,
): BetslipSportsbookConfirmationBet["runners"] => getSportsbookConfirmation(appState)?.runners || {};

export const getSportsbookConfirmationCastContext = (
  appState: BetslipApplicationState,
): BetslipCastContext | undefined => getSportsbookConfirmation(appState)?.castContext;
